import Sidebar from "../../components/Sidebar";
import { useUser } from "../../context/UserContext";

const Dashboard = () => {
  const { user } = useUser();

  return <Sidebar user={user} />;
};

export default Dashboard;
